import React from "react";
import AbstractPage from "./AbstractPage";

class VFL extends AbstractPage {
  constructor(props) {
    super(props)

    this.title = "VFL";
  }

  render() {
    return ""
  }
}

export default VFL;



// WEBPACK FOOTER //
// ./src/views/VFL.js